import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Back from "~/components/Icons/arrow-prev2";
import Button from "~/shared/ui/Fields/Button";

const TableControl = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const goBack = () => {
    history.replace("/editor/cep/ptp");
  };

  return (
    <div>
      <Button txtBtn={t("ui.back")} onClick={goBack} small>
        <Back />
      </Button>
    </div>
  );
};

export default TableControl;
